import fp from 'lodash/fp'

const createFormatFunction = (prop) =>
  fp.map((option) => {
    const { [prop]: id, description } = option

    return {
      id: id || option,
      name: description || fp.capitalize(option),
    }
  })

export const getOptionLabel = fp.prop('name')

export const getOptionValue = fp.prop('id')

export const formatCategories = createFormatFunction('category')

export const formatSubcategories = createFormatFunction('subCategory')

export const toSearchableCategory = fp.map(getOptionValue)
